module.exports = "@media only screen and (max-width: 991px) and (min-width: 577px) {\n  #menu2 {\n    padding-bottom: 21px;\n    padding-top: 21px; } }\n"